export const scopeOrderFields = `
  id
  _version
  _deleted
  createdAt
  updatedAt
  type
  accountOwnerId
  accountOwnerName
  creatorDoctorId
  practiceName
  shippingAddress
  country
  items
  paymentType
  source
  stripeInvoiceId
  amount
  currency
  invoiceUrl
  status
  statusUpdatedAt
  shipbobUpdatesDisabled
  shipbobOrderId
  shipbobReferenceId
  shippingMethod
  shipments
  internalNote
`

export const scopeOrderDetailFields = `
  ${scopeOrderFields}
  audit
`

export const scopeOrdersByTypeSorted = /* GraphQL */ `
  query ScopeOrdersByTypeSorted($type: String!, $sortDirection: ModelSortDirection, $limit: Int, $nextToken: String) {
    scopeOrdersByTypeSorted(type: $type, sortDirection: $sortDirection, limit: $limit, nextToken: $nextToken) {
      items {
        ${scopeOrderFields}
      }
      nextToken
    }
  }
`

export const getScopeOrder = /* GraphQL */ `
  query GetScopeOrder($id: ID!) {
    getScopeOrder(id: $id) {
      ${scopeOrderDetailFields}
    }
  }
`
